import axios from "axios";
import React, { useEffect, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";

const EditNiosPricing = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();
  const [niosClass, setNiosClass] = useState([]);
  const [niosClassId, setNiosClassId] = useState();
  const [niosSubject, setNiosSubject] = useState([]);
  const [niosSubjectId, setNiosSubjectId] = useState();
  const [price, setPrice] = useState();
  const { id } = useParams();

  const handleAddNiosPricing = () => {
    navigate("/exam-notes-pricing/add-nios-pricing");
  };
  const handleViewAllNiosPricing = () => {
    navigate("/exam-notes-pricing/all-nios-pricing");
  };
  const handleGoBack = () => {
    navigate("/exam-notes-pricing");
  };

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/pricing/exam-notes/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((result) => {
        console.log(result);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const payload = {
    niosSubjectId,
    price,
    type: "nios",
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .put(`${API_BASE_URL}/admin/pricing/exam-notes/${id}`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((result) => {
        console.log(result);
        alert("Nios Notes Price Added.");
      })
      .catch((error) => {
        console.log(error);
        alert("Error while Adding Price.");
      });
  };
  return (
    <div id="exam-school-notes-inner-wrapper">
      <div className="main-header">
        <BiArrowBack
          onClick={handleGoBack}
          className="left-arrow-icon"
          style={{
            cursor: "pointer",
            display: "flex",
            fontSize: "25px",
            color: "#000",
          }}
        />
        <div className="exam-header-div">
          <h5>Nios Notes Pricing</h5>
          <div className="exam-btn-group">
            <button className="addNewNoteBtn" onClick={handleAddNiosPricing}>
              + Add Nios Pricing
            </button>
            <button
              className="viewAllNotesBtn"
              onClick={handleViewAllNiosPricing}
            >
              + Add Nios Pricing
            </button>
          </div>
        </div>

        <div className="form-container" id="form">
          <h4 className="note-detail">Add Nios Note Price</h4>
          <form onSubmit={handleSubmit} className="note-detail-form">
            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Class Name</label>
              </div>
              <select
                className="select-dropdown"
                value={niosClassId}
                onChange={(e) => setNiosClassId(e.target.value)}
                required
              >
                <option value="">-Select Class-</option>
                {niosClass &&
                  niosClass.map((classes) => (
                    <option value={classes._id} key={classes._id}>
                      {classes?.className}
                    </option>
                  ))}
              </select>
            </div>

            <div className="new-chapter-form-group">
              <label className="new-chapter-label">Subject Name</label>
              <select
                className="new-chapter-dropdown"
                value={niosSubjectId}
                onChange={(e) => setNiosSubjectId(e.target.value)}
                required
              >
                <option value="">-Select Subject-</option>
                {niosSubject.map((subject, idx) => (
                  <option key={idx} value={subject._id}>
                    {subject.subjectName}
                  </option>
                ))}
              </select>
            </div>

            <div className="input-group">
              <label className="label">Note Price</label>
              <input
                type="text"
                className=""
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                placeholder="Enter Note Price"
                required
              />
            </div>

            <div className="form1-btns">
              <button className="btn-save">Save</button>
              <button
                type="button"
                className="btn-cancel"
                onClick={handleGoBack}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditNiosPricing;
